// Translation
import { useTrans } from "@/i18n"

// UI
import { Card } from "@/components/Card"
import { Heading } from "@/components/Typography"

// Specific UI
import { InvestorIdentityForm } from "./_components/InvestorIdentityForm"
import { BusinessVerificationForm } from "./_components/BusinessVerificationForm"
import { MangoPaySCABanner } from "./_components/MangopayScaBanner"

// Icons
import { FiAlertTriangle } from "@/lib/icons"

// Context
import { useCurrentUserIdentityType } from "@/context/user"

// API
import { UsersUserProfileIdentityTypeChoices } from "@/api/graphql"

/**
 * InvestorIdentity
 * @returns
 */
export const InvestorIdentity = () => {
	const t = useTrans("investor")
	const identity_type = useCurrentUserIdentityType()

	return (
		<>
			<title>
				{t("common:common.web.title", {
					page: t("investor:investor.identity.title"),
				})}
			</title>

			<MangoPaySCABanner />

			{identity_type === UsersUserProfileIdentityTypeChoices.Business ? (
				<BusinessVerificationForm />
			) : (
				<InvestorIdentityForm />
			)}
		</>
	)
}

/**
 * KycDisabledOverlay
 *
 * TODO: Remove this once kyc is available again
 * @returns
 */
export const KycDisabledOverlay = () => {
	// i18n
	const t = useTrans("investor")

	// Template
	return (
		<div className="absolute inset-0 z-10 bg-gray-600 bg-opacity-50 p-5 text-center text-lg">
			<Card className="mx-auto max-w-xl">
				<div className="space-y-4 text-center">
					<Heading
						as="h2"
						styleAs="h5"
						className="flex justify-center gap-2"
					>
						<div className="flex items-center">
							<FiAlertTriangle
								className="size-6 text-yellow-400"
								aria-hidden="true"
							/>
						</div>
						{t(
							"investor:investor.identity.copy.banner.disabled.title",
						)}
					</Heading>
					<p className="text-left text-gray-500">
						{t(
							"investor:investor.identity.copy.banner.disabled.copy",
						)}
					</p>
					<p className="text-left text-gray-500">
						{t(
							"investor:investor.identity.copy.banner.disabled.email",
						)}
					</p>
					<p className="text-left font-bold">
						{t(
							"investor:investor.identity.copy.banner.disabled.investment",
						)}
					</p>
				</div>
			</Card>
		</div>
	)
}
